import { config } from "../../config";

// Product VAT moves to VAT rules in the new admin (heapsgo-admin-web).
export const heapsGoAdminVatRulesUrl = (organizationKeyName: string) =>
  `${config.heapsGoAdminUrl}/hgo/${organizationKeyName}/vat/rules`;

// A product moves to another VAT rule on its own form there.
export const heapsGoAdminProductUrl = (
  organizationKeyName: string,
  productId: string
) =>
  `${config.heapsGoAdminUrl}/hgo/${organizationKeyName}/products/${productId}`;
